import { Container, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import PrimaryButton from "../../../util/Btns/PrimaryButton";
import forceUpdateIcon from "../../../Assets/applifecycle/force-update.svg";


import styles from "./RemarksModal.module.scss";
import Close from "../../../Assets/close.svg";
import {
  getStatus,
  sliceString,
} from "../../../util/helpers/funcHelper";
import ReactTooltip from "react-tooltip";
import Info from "../../../Assets/info.svg";
import { appStatus } from "../../../util/helpers/statusHelper";

import {
  useAppConfig,
} from "../../../hooks/DevAppHooks";
import ConsoleLocalStorage from "../../../storage/storage";



const ForceUpdateModal = ({
  showForceUpModal,
  setShowForceUpModal,
  buildStatusData,
  setForceUpdateVersion,
  forceUpdateInfo,
  app
}) => {
  const { data: configData } = useAppConfig(
    ConsoleLocalStorage.getOrganization().tags
  );
  const handleClose = () => setShowForceUpModal("false");

  const [updateVersion, setUdateVersion] = useState({
    minUpdVerCode: buildStatusData?.[0]?.packageCode || null,
    minUpdVerName: buildStatusData?.[0]?.version || null
  });

  useEffect(() => {
    console.log('updateVersionupdateVersionupdateVersion', updateVersion)
  }, [updateVersion])
  return (
    <>
      <Container>

        <Modal
          show={showForceUpModal === "true"}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Body >
            <div className={`${styles.body} release-modal`}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h3> Select Build Version </h3>
                <img
                  onClick={() => setShowForceUpModal("false")}
                  src={Close}
                  height="14"
                  width="14"
                  alt="cross"
                  className="cursor-pointer"
                />
              </div>
              <div className={styles.buildstatus}>
                <table
                  className={styles.buildStatusTable}
                  style={{ textAlign: "center" }}
                >
                  <tr
                    style={{
                      height: "50px",
                      borderBottom: "2px solid rgba(110, 110, 110, 1)",
                    }}
                  >
                    <th>Select</th>
                    <th>Build Name</th>
                    <th>Version Code</th>
                    <th>Size</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Published date</th>
                    <th>Devices</th>
                    <th>Force Update</th>
                  </tr>
                  {buildStatusData?.map((item, index) => (
                    <tr
                    style={{
                      height: "50px",
                      borderBottom: "1px solid rgba(110, 110, 110, 1)",
                    }}
                    >
                      <td>

                        <input
                          type="radio"
                          a={item}
                          id={item.packageCode}
                          // value={{ minUpdVerCode: item.packageCode, minUpdVerName: item.version }}
                          checked={updateVersion.minUpdVerCode !== null ? (item.packageCode === updateVersion.minUpdVerCode) : index === 0}
                          onClick={() => {
                            setUdateVersion({ minUpdVerCode: item.packageCode, minUpdVerName: item.version })
                          }}
                        />
                      </td>
                      <td className={styles.tooltip}>
                        {sliceString(0, 10, item.version, true)}
                        {item.version.length > 10 ? (
                          <>
                            <a className="publisher_i_btn">
                              <img
                                data-class="myTooltipClass"
                                data-tip={item.version}
                                src={Info}
                                alt="category-icon"
                              />
                            </a>
                            <ReactTooltip
                              arrowColor="transparent"
                              backgroundColor="#707070"
                              place="right"
                              type="dark"
                              effect="solid"
                              delayShow={100}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </td>

                      <td>{item.packageCode ? item.packageCode : "-"}</td>
                      <td>{Math.ceil(item.size / 1024)} MB</td>
                      <td>{getStatus(item?.status, appStatus?.release, true)}</td>
                      <td>{item.created_at}</td>
                      <td>{item.updated_at}</td>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-evenly",
                          gap: "4px",
                          padding: "12px",
                        }}
                      >
                        {item.platform.map((plat) => {
                          let index = configData?.platform?.[app.appOS]?.findIndex(
                            (item) => item.value === plat
                          );
                          if (index > -1) {
                            return (
                              <img
                                src={configData?.platform?.[app.appOS][index]?.icon}
                                style={{ width: "40px", height: "40px" }}
                                alt=""
                              />
                            );
                          }
                        })}
                      </td>
                      <td>
                        {
                          (item.forceUpdate == true) &&
                          <Tooltip title={item.minUpdVerName || "-"} placement="bottom">
                            <img
                              src={forceUpdateIcon}
                              className="ws-30 c-pointer force-update-icon"
                              style={{ borderRadius: "100px", background: "#404040", padding: "9px" }}
                              alt=""
                            />
                          </Tooltip>
                        }
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
              <PrimaryButton onClick={() => {
                // setShowForceUpModal("false")
                setForceUpdateVersion(updateVersion)
              }
              } style={{ margin: "15px auto 0" }}>
                Okay
              </PrimaryButton>
              {/* </div> */}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default ForceUpdateModal;
